import { render, staticRenderFns } from "./LazyElementsTree.vue?vue&type=template&id=0e487dca&scoped=true"
import script from "./LazyElementsTree.vue?vue&type=script&lang=js"
export * from "./LazyElementsTree.vue?vue&type=script&lang=js"
import style0 from "./LazyElementsTree.vue?vue&type=style&index=0&id=0e487dca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e487dca",
  null
  
)

export default component.exports